import en from './locale/en';
import pt_BR from './locale/pt_BR';
const localeModules = {
  ar: () => import('./locale/ar'),
  bg: () => import('./locale/bg'),
  ca: () => import('./locale/ca'),
  cs: () => import('./locale/cs'),
  da: () => import('./locale/da'),
  de: () => import('./locale/de'),
  el: () => import('./locale/el'),
  es: () => import('./locale/es'),
  et: () => import('./locale/et'),
  fa: () => import('./locale/fa'),
  fi: () => import('./locale/fi'),
  fr: () => import('./locale/fr'),
  he: () => import('./locale/he'),
  hi: () => import('./locale/hi'),
  hu: () => import('./locale/hu'),
  id: () => import('./locale/id'),
  it: () => import('./locale/it'),
  ja: () => import('./locale/ja'),
  ko: () => import('./locale/ko'),
  lv: () => import('./locale/lv'),
  ml: () => import('./locale/ml'),
  nl: () => import('./locale/nl'),
  no: () => import('./locale/no'),
  pl: () => import('./locale/pl'),
  pt: () => import('./locale/pt'),
  ro: () => import('./locale/ro'),
  ru: () => import('./locale/ru'),
  sk: () => import('./locale/sk'),
  sl: () => import('./locale/sl'),
  sr: () => import('./locale/sr'),
  sv: () => import('./locale/sv'),
  ta: () => import('./locale/ta'),
  th: () => import('./locale/th'),
  tr: () => import('./locale/tr'),
  uk: () => import('./locale/uk'),
  uz: () => import('./locale/uz'),
  vi: () => import('./locale/vi'),
  zh_CN: () => import('./locale/zh_CN'),
  zh_TW: () => import('./locale/zh_TW'),
  is: () => import('./locale/is'),
  lt: () => import('./locale/lt'),
};
let latestLocaleRequest = 0;

export const setDashboardLocale = async (i18n, locale) => {
  if (!locale) return false;

  latestLocaleRequest += 1;
  const request = latestLocaleRequest;
  try {
    if (!i18n.availableLocales.includes(locale)) {
      const load = localeModules[locale];
      if (!load) return false;
      i18n.setLocaleMessage(locale, (await load()).default);
    }

    if (request !== latestLocaleRequest) return false;
    if (typeof i18n.locale === 'string') {
      i18n.locale = locale;
    } else {
      i18n.locale.value = locale;
    }
    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Failed to load dashboard locale ${locale}`, error);
    return false;
  }
};

export default {
  en,
  pt_BR,
};
